// extracted by mini-css-extract-plugin
module.exports = {"containerFeCorrection":"styles_containerFeCorrection__qN4It"};